export default {
  title: 'Bestellungs-Portal',
  form: {
    username: {
      placeholder: 'Benutzername',
    },
    password: {
      placeholder: 'Passwort',
    },
  },
  buttons: {
    submit: 'Anmelden',
  },
  toasts: {
    auth_token_invalid:
      'Das bereitgestellte Authentifizierungs-Token ist ungültig. Bitte melde dich mit deinen Zugangsdaten an',
    credentials_invalid: 'Falsch Benutzername oder Passwort',
  },
};
